export const linkTranslation = {
  delete: 'link-delete',
}
